module.exports = __webpack_public_path__ + "img/register.14050e5a.svg";